import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../Shared/API/config';
import { studentsApi } from '../Students/StudentsApi';

export interface PendingActivation {
  studentId: number;
  studentName: string;
  classroomId: number | null;
  classroomName: string;
  balance: string;
  debit: string;
  sessionId: number;
}

export interface Installment {
  amount: string;
  dueDate: string;
}

export const termActivationApi = createApi({
  reducerPath: 'termActivationApi',
  baseQuery,
  tagTypes: ['PendingActivations'],
  endpoints: builder => ({
    getPendingActivations: builder.query<PendingActivation[], void>({
      query: () => '/enrollment/term-activation/pending',
      transformResponse: (response: { data: PendingActivation[] }) => response.data,
      providesTags: [{ type: 'PendingActivations', id: 'LIST' }],
    }),
    createTermActivationPromise: builder.mutation<
      void,
      { studentId: number; installments: Installment[] }
    >({
      query: ({ studentId, ...body }) => ({
        url: `/enrollment/students/${studentId}/term-activation/promise`,
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'PendingActivations', id: 'LIST' }],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(studentsApi.util.invalidateTags(['Student']));
        } catch (e) {
          console.error(e);
        }
      },
    }),
    activateTermActivation: builder.mutation<void, { studentId: number }>({
      query: ({ studentId }) => ({
        url: `/enrollment/students/${studentId}/term-activation/activate`,
        method: 'POST',
      }),
      invalidatesTags: [{ type: 'PendingActivations', id: 'LIST' }],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(studentsApi.util.invalidateTags(['Student']));
        } catch (e) {
          console.error(e);
        }
      },
    }),
  }),
});

export const {
  useGetPendingActivationsQuery,
  useCreateTermActivationPromiseMutation,
  useActivateTermActivationMutation,
} = termActivationApi;
